export const PermissionTypes = {
  TIMELINE: 'timeline',
  BUDGETS: 'budgets',
  DATA_ACCESS: 'data.access',
  DATA_BUDGET: 'data.budget',
  DATA_TRAVEL: 'data.travel',
  DATA_ESG: 'data.esg',
  DATA_STATEMENT: 'data.statement',
};
